const inkeep_ai_bot = {
    intro_message: 'سلام، من Logto AI هستم!\n\nمن یک دستیار هوش مصنوعی هستم که بر اساس مستندات، مقالات راهنما و سایر محتواها آموزش دیده‌ام.\n\nهر سوالی درباره `Logto` دارید بپرسید.',
    chat_placeholder: 'سوال خود را از Logto AI بپرسید تا راهنمایی گام به گام دریافت کنید',
    disclaimer_label: 'سلب مسئولیت Logto AI',
    disclaimer_tooltip: 'پاسخ‌ها توسط هوش مصنوعی تولید شده‌اند و ممکن است نیاز به تأیید داشته باشند.',
    example_questions_label: 'سوالات نمونه',
    example_questions: [
        'راهنمای شروع سریع برای راه‌اندازی Logto',
        'پیکربندی معماری چند مستأجری',
        'چگونه پروفایل کاربر را یکپارچه کنیم؟',
    ],
    stop: 'توقف',
    clear: 'شروع مجدد',
    get_help: 'دریافت کمک',
    copy_chat: 'کپی',
    ask_ai_label: 'پرسش از هوش مصنوعی',
    contact: 'تماس',
    discord: 'دیسکورد',
};
export default Object.freeze(inkeep_ai_bot);
